module.exports = __webpack_public_path__ + "img/harmony_feature_02.e4b3bb73.jpg";